import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

const Result = () => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.model);
        
    const cancelHandler = () => dispatch(resetModel());

    // const confirmText = {
    //     // C: '已傳送交修結果',
    //     P: '請靜待服務廠人員聯繫'
    // };

    const confirmText = (data) => {
        if (data === 'C') {
          return (
            <>
                <div><span>謝謝您</span></div>
                <div><span>我們會依照您同意的交修內容施作</span></div>
                <div><span>也請留意訊息</span></div>
                <div><span>愛車保修完成後</span></div>
                <div><span>我們會再與您聯繫</span></div>
            </>
          )
        } else if (data === 'P') {
          return (
            <>
                <div><span>謝謝您</span></div>
                <div><span>專屬服務人員將儘快與您聯繫</span></div>
                <div><span>請留意手機通知</span></div>
            </>
          )
        }
    }

    const confirmation = () => {
        cancelHandler();
    };

    return (
        <Modal show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">
                    {/* <h2>{ confirmText[data] }</h2> */}
                    <h2>{ confirmText(data) }</h2>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ confirmation }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default Result;